import { AlloyModal } from '@adsk/napi-shared'
import { useState } from 'react'
import Button from '@adsk/alloy-react-button'
import styled from 'styled-components'
import Theme from '@adsk/alloy-react-theme'
import { startPendoGuides } from '../../utils/pendo'
import { useTranslation } from '../../../i18n'

const Paragraph = styled.p`
	font-weight: lighter;
	justify-content: center;
	text-align: left;
`
export const ErrorModal = ({ isFetchFailure = false }): JSX.Element => {
	const [isOpen, setIsOpen] = useState(true)
	const { typography } = Theme
	const { t } = useTranslation()

	return (
		<AlloyModal
			open={isOpen}
			size={AlloyModal.SIZES.SMALL}
			shouldCloseOnEsc
			height={'auto'}
		>
			<AlloyModal.Header disableBorder>
				<div style={typography.heading1}>
					{isFetchFailure
						? t('VIEW_PROFILE_HEADER')
						: t('PROFILE_SAVE_ERROR_HEADER')}
				</div>
				<AlloyModal.Close
					aria-label="close"
					onClick={() => {
						setIsOpen(false)
						startPendoGuides()
					}}
				/>
			</AlloyModal.Header>
			<AlloyModal.Body>
				<Paragraph style={typography.bodyMedium}>
					{isFetchFailure
						? t('PROFILE_FETCH_ERROR_BODY1')
						: t('PROFILE_SAVE_ERROR_BODY1')}
				</Paragraph>
				<Paragraph style={typography.bodyMedium}>
					{isFetchFailure
						? t('PROFILE_FETCH_ERROR_BODY2')
						: t('PROFILE_SAVE_ERROR_BODY2')}
				</Paragraph>
			</AlloyModal.Body>
			<AlloyModal.Footer disableBorder={true}>
				<Button
					variant={Button.VARIANTS.PRIMARY}
					onClick={() => {
						setIsOpen(false)
						startPendoGuides()
					}}
				>
					{t('OK')}
				</Button>
			</AlloyModal.Footer>
		</AlloyModal>
	)
}
